import React, { useState, useEffect } from "react";
import isEmail from "validator/lib/isEmail";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link, useNavigate, useParams } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from '@mui/material/CircularProgress';

import "../App.scss";

const fullNameRegex = /^([A-Za-zÀ-ÖØ-öø-ÿ'-]+ +)+[A-Za-zÀ-ÖØ-öø-ÿ'-]+$/;

const Invite = () => {

  let navigate                              = useNavigate();
  const { id }                              = useParams();

  const [isSaving, setIsSaving]             = useState(false);
  const [isFormValid, setIsFormValid]       = useState(false);

  // const [list, setList]                     = useState([]);
  const [invitees, setInvitees]             = useState([]);
  const [firstRowName, setFirstRowName]     = useState("");
  const [firstRowEmail, setFirstRowEmail]   = useState("");

  useEffect(() => {
    document.body.style.backgroundColor = "#152036";
    document.getElementById('assessment-title').style.color = "#1F2A44";
    let invitee = [{
      id: 1,
      name: "",
      email: "",
      showFullName: false,
      showEmail: false
    }]
    setInvitees(invitee);
  }, []);
  
  const submitToApi = (member) => {

    const payload = {
      members: member
    }
    
    fetch(process.env.REACT_APP_API_URI + '/v1/assessment/share/' + id, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(response => {
      return response.json();
    }).then(data => {
      if(data.status == "success") {
        navigate("/invite-team-thanks/" + id, { replace: true });
      } else {
        setIsSaving(false);
        // setOpenSnackbar(true);
      }
    });

  }

  const handleSubmit = () => {
    setIsSaving(true);

    let formHasError = false;
  
    const updatedInvitees = invitees.map((invitee) => {
      let showFullName = false;
      let showEmail = false;
      if (!invitee.name || !fullNameRegex.test(invitee.name.trim())) {
        showFullName = true;
        formHasError = true;
      }
      if (!invitee.email || !isEmail(invitee.email)) {
        showEmail = true;
        formHasError = true;
      }
      return { ...invitee, showFullName, showEmail };
    });
    setInvitees(updatedInvitees);
    if (formHasError) {
      setTimeout(() => { setIsSaving(false); }, 500);
    } else {
      submitToApi(updatedInvitees);
    }
  };  

  const deletePerson = (p) => {    
    setInvitees(invitees.filter((person) => {
      return person.id !== p
    }));
  };

  const addPerson = () => {
    
    let id        = 2;
    if(invitees.length > 0) {
      id          = invitees[invitees.length - 1].id + 1;
    }
    
    let person = {
      id: id,
      name: "",
      email: ""
    }
    setInvitees([...invitees, person]);

  };

  const updateName = (e, id) => {
    let currentMember       = invitees.find(function (obj) { return obj.id == id; });
    currentMember.name      = e.target.value;
  }

  const updateEmail = (e, id) => {
    let currentMember       = invitees.find(function (obj) { return obj.id == id; });
    currentMember.email     = e.target.value;
  }

  const showButton = () => {
    if(isSaving) {
      return <div className="button-progress"><CircularProgress style={{'color': '#fff'}} size={23} /></div>
    }
    return "SEND INVITE";
  }

  const removeError = (id, field) => {
    let newinvitees = [];
    invitees.forEach(invitee => {
      if(field == "fullName" && invitee.id == id) {
        invitee.showFullName = false;
      }
      if(field == "email" && invitee.id == id) {
        invitee.showEmail = false;
      }
      newinvitees.push(invitee);
    });
    setInvitees(newinvitees);
  }


  return (
    <>
      <div className="container invite">
        <div className="details-container">
          <h1>Invite your team members</h1>
          <p>Get your team to take this test and compare the<br/>
          collective results so you can align around effective action.</p>

          {
            invitees.map((data, index) => (
              <div className="form _form" key={data.id}>        
                <div className="invite-number">{index + 1}.</div>        
                <div className="form-detail">
                  <p>Full name</p>
                  <TextField hiddenLabel placeholder="Simon Peter" onFocus={(e) => {removeError(data.id, "fullName")}} onChange={(e) => {updateName(e, data.id)}} fullWidth variant="standard" size="normal" InputProps={{ disableUnderline: true }} className="invite-field" />
                  {data.showFullName && (
                    <div className="error-text">Please enter full name</div>
                  )}
                </div>
                <div className="form-detail">
                  <p>Email</p>
                  <TextField hiddenLabel placeholder="simon@rockchurch.com" onFocus={(e) => {removeError(data.id, "email")}} onChange={(e) => {updateEmail(e, data.id)}} fullWidth variant="standard" size="normal" InputProps={{ disableUnderline: true }} className="invite-field" />
                  { 
                    data.showEmail ?
                      <div className="error-text">Please enter a valid email</div>
                    : null
                  }
                </div>
                { data.id != 1 ?
                  <div className="delete-btn">
                    <div onClick={() => deletePerson(data.id)}>
                      <DeleteIcon className="delete-icon" />
                    </div>
                  </div>
                  : null
                }
              </div>
            ))
          }
          
          <div className="invite-another-person">
            <div className="invite-another">
              
              <div className="form_icons--icon">
                <div onClick={addPerson} className="icon-btn">
                  +ADD
                </div>
              </div>
            </div>
          </div>
          
          <Button className="cta-btn" disabled={isSaving} onClick={() => handleSubmit()}>{showButton()}</Button>

        </div>
      </div>
    </>
  );

};
export default Invite;